// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"25bae932","703":"6126f58e","787":"d0c1d8f4"}[chunkId] + ".chunk.js";
};